import { Button, Input, Modal, Pagination, Table } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { isSearchSwiftModalOpenAC } from '@store/reducers/payments';
import { searchSwiftApi } from '@http/payments';

const SearchSwiftModal = ({ selectSwiftHandler }: any) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const searchedSwift = useAppSelector(state => state.paymentsReducer.searchedSwift);
  const isSearchSwiftModalOpen = useAppSelector(state => state.paymentsReducer.isSearchSwiftModalOpen);

  const [searchSwiftQuery, setSearchSwiftQuery] = useState({
    bic: '',
    name: '',
    city: '',
    country: '',
  });

  const searchSwift = () => {
    dispatch(searchSwiftApi(searchSwiftQuery));
  };

  const changePage = (page: number) => {
    dispatch(searchSwiftApi({ page, ...searchSwiftQuery }));
  };

  const columns = [
    {
      title: 'Swift код',
      dataIndex: 'bic_code',
      key: 'bic_code',
    },
    {
      title: t('Bank name'),
      dataIndex: 'bank_name',
      key: 'address',
    },
    {
      title: t('Address'),
      dataIndex: 'bank_address',
      key: 'bank_address',
    },
  ];

  return (
    <div>
      <Modal
        width={700}
        footer={null}
        title={t('Find swift code')}
        open={isSearchSwiftModalOpen}
        onOk={() => dispatch(isSearchSwiftModalOpenAC(false))}
        onCancel={() => dispatch(isSearchSwiftModalOpenAC(false))}
      >
        <div>
          <div>
            <p>Swift</p>
            <Input
              placeholder='Swift'
              onChange={e => {
                setSearchSwiftQuery({ ...searchSwiftQuery, bic: e.target.value });
              }}
            />
          </div>
          <div className='mt-5'>
            <p>{t('Bank name')}</p>
            <Input
              placeholder={`${t('Bank name')}`}
              onChange={e => {
                setSearchSwiftQuery({ ...searchSwiftQuery, name: e.target.value });
              }}
            />
          </div>
          <div className='flex justify-end mt-5'>
            <Button type='primary' onClick={searchSwift}>
              {t('Find')}
            </Button>
          </div>
          <div className='mt-5'>
            <Table
              pagination={false}
              rowKey='swift'
              columns={columns}
              dataSource={searchedSwift.data}
              onRow={(item: any) => ({
                onDoubleClick: () => {
                  selectSwiftHandler(item);
                },
              })}
            />
            {searchedSwift?.data?.length > 0 ? (
              <div className='mt-7 flex justify-end'>
                <Pagination
                  onChange={changePage}
                  current={searchedSwift.page}
                  defaultPageSize={10}
                  total={searchedSwift.total_pages * 10}
                  showSizeChanger={false}
                />
              </div>
            ) : null}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SearchSwiftModal;
